import { store } from '../store/store';
import { baiduReportAPI, GetNotifyKey } from '../service/getData';
import { Toast } from 'vant';

/**
 * 百度转化埋点统计代码
 * @param {*} obj.newType 转化类型
 * @param {string|undefined} obj.orderNo 订单编号
 * @param {string} obj.mobile 手机号码
 */
export const baiduReport = async (obj) => {
	try {
		// 如果是百度OCPC推广进来的用户，调用用户转化接口
		const href = decodeURIComponent(window.location.href.replace(location.hash, ''));
		// const bd_vid = sessionStorage.getItem("bd_vid");
		// const sg_vid = sessionStorage.getItem("sg_vid");
		// const qhclickid = sessionStorage.getItem("qhclickid");
		const channel = store.state.channel || store.state.businessNo;
		let { data } = await GetNotifyKey({ businessNo: channel });
		let vidName = data.result;
		let vidValue = sessionStorage.getItem(vidName);
		const ttclick = sessionStorage.getItem('ttclick');
		if (
			// href.toString().indexOf("bd_vid") > -1 ||
			// href.toString().indexOf("sg_vid") > -1 ||
			// href.toString().indexOf("qhclickid") > -1
			href.toString().indexOf(vidName) > -1 &&
			href
		) {
			baiduReportAPI({
				logidUrl: href,
				newType: obj.newType,
				businessNo: channel,
				orderNo: obj.orderNo,
				mobile: obj.mobile
			});
		} else if (vidValue) {
			baiduReportAPI({
				// logidUrl: `${href}${window.location.search ? "&" : "?"}${
				//   bd_vid ? "bd_vid" : sg_vid ? "sg_vid" : qhclickid ? "qhclickid" : ""
				// }=${bd_vid || sg_vid || qhclickid}`,
				logidUrl: `${href}${window.location.search ? '&' : '?'}${vidName}=${vidValue}`,
				newType: obj.newType,
				businessNo: channel,
				orderNo: obj.orderNo,
				mobile: obj.mobile
			});
		} else if (ttclick) {
			baiduReportAPI({
				logidUrl: ttclick,
				newType: obj.newType,
				businessNo: channel,
				orderNo: obj.orderNo,
				mobile: obj.mobile
			});
		}
	} catch (err) {}
};

/**
 * 获取地址栏参数
 * @param {*} name
 * @returns
 */
export const QueryString = (name) => {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	let r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURIComponent(r[2]);
	return null;
};

// //获取地址栏参数
export const getUrlParams = (name) => {
	let url = window.location.href;
	let index = url.indexOf('?');
	let params = [];
	if (index > -1) {
		params = url.slice(index + 1).split('&');
	}
	var query = {};
	for (var i = 0; i < params.length; i++) {
		var temp = params[i].split('=');
		if (temp) query[temp[0]] = temp[1];
	}
	var type = query[name]; //渠道
	return type ? type : null;
};

export const CopyText = (text) => {
	const textToCopy = text;
	// 使用 Clipboard API（异步方式）
	if (navigator.clipboard) {
		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				Toast('复制成功');
			})
			.catch((error) => {
				// // 处理不同类型的错误
				// if (error.name === "NotAllowedError") {
				//   Toast("用户拒绝了剪贴板访问权限");
				// } else if (error.name === "SecurityError") {
				//   Toast("浏览器限制了对剪贴板的访问");
				// } else {
				//   Toast("复制操作发生错误:", error);
				// }
				const tempInput = document.createElement('textarea');
				tempInput.value = textToCopy;
				document.body.appendChild(tempInput);

				tempInput.select();
				tempInput.setSelectionRange(0, 99999); // 兼容iOS

				try {
					document.execCommand('copy');
					Toast('复制成功');
				} catch (err) {
					Toast('复制失败，请手动复制');
				}

				document.body.removeChild(tempInput);
			});
	}
	// 使用 document.execCommand() 方法（同步方式）
	else {
		const tempInput = document.createElement('textarea');
		tempInput.value = textToCopy;
		document.body.appendChild(tempInput);

		tempInput.select();
		tempInput.setSelectionRange(0, 99999); // 兼容iOS

		try {
			document.execCommand('copy');
			Toast('复制成功');
		} catch (err) {
			Toast('复制失败');
		}

		document.body.removeChild(tempInput);
	}
};



// WEBPACK FOOTER //
// ./src/js/common.js